module.exports = __webpack_public_path__ + "img/friendly-room-3.abe9175e.jpg";